<template>
  <div>   
    <v-container grid-list-md fluid>
      <v-layout align-center justify-space-around wrap>
        <v-flex md8>
          <v-card>
            <v-layout>
              <v-flex xs5>
                <v-img max-height="100px" max-width="100px" contain :src="require(`@/assets/walrus.jpg`)"></v-img>
              </v-flex>
              <v-flex xs7>
                <v-card-title primary-title>
                  <h3 class="headline mb-0">ImageMaker</h3>
                </v-card-title>
                <v-card-text>Make and download images</v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
